import type { Locale } from "@salon-pos/shared";
import type { ReactNode } from "react";
import { LOCALE_LABELS, useI18n } from "../i18n";
import { ServerLongPress } from "../native/ServerSetting";
import { SenviaIcon } from "./SenviaLogo";
import { PublicSupportAssistant } from "./PublicSupportAssistant";

/** Public pages (sign in, sign up, verify, invite): calm centered card, optional side panel, language picker, (Public assistant) the Senvia 助手 bubble for visitors. */
export function AuthLayout({ children, aside }: { children: ReactNode; aside?: ReactNode }) {
  const { t, locale, setLocale, locales } = useI18n();
  return (
    <div className="auth-page">
      <header className="auth-top">
        <ServerLongPress><div className="brand senvia-brand" data-testid="senvia-brand"><SenviaIcon size={30} /><span className="brand-name">{t("app.name")}</span></div></ServerLongPress>
        <label className="lang-pick">
          <span className="sr-only">{t("common.language")}</span>
          <select value={locale} onChange={(e) => setLocale(e.target.value as Locale)}>
            {locales.map((l) => <option key={l} value={l}>{LOCALE_LABELS[l as Locale]}</option>)}
          </select>
        </label>
      </header>
      <main className={"auth-main" + (aside ? " with-aside" : "")}>
        {children}
        {aside}
      </main>
      <PublicSupportAssistant />
    </div>
  );
}
